// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDataPieChartSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 6.25c0-.138.112-.25.25-.245a6 6 0 0 1 5.745 5.745.242.242 0 0 1-.245.25h-5.5a.25.25 0 0 1-.25-.25z"
    />
    <path
      fill="currentColor"
      d="M10.5 6.513V7.58c0 .106-.067.2-.166.239a4.501 4.501 0 1 0 5.847 5.846.259.259 0 0 1 .24-.165h1.066a.24.24 0 0 1 .234.31 6.002 6.002 0 0 1-9.886 2.509 6 6 0 0 1 2.355-10.04.24.24 0 0 1 .31.234z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zm0 2H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDataPieChartSquare;
